import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, inject, onBeforeMount } from "vue";
import Storage from "@/core/config/Storage";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { locale } = useI18n();
const store = useStore();
const setting = ref() as any;

onBeforeMount(async () => {
  let settingValue = store.getters["siteSetting/getList"].data;
  while (!settingValue) {
    await new Promise((resolve) => setTimeout(resolve, 100));
    settingValue = store.getters["siteSetting/getList"].data;
  }
  setting.value = settingValue;

  locale.value = Storage.getLang() ?? "en";
  Storage.setLang(locale.value);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, {
    justify: "center",
    style: {"height":"100vh"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(`body-view position-relative style-1`),
        style: _normalizeStyle({
        boxShadow: `var(--el-box-shadow-dark)`,
      })
      }, [
        _createVNode(_component_router_view)
      ], 4)
    ]),
    _: 1
  }))
}
}

})